import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border border-blue-500 p-1 text-xs rounded-md bg-blue-400 text-white font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(new Intl.NumberFormat('en-US').format(_ctx.balance)) + " IQD ", 1))
}